"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconGuestsFilled = function IconGuestsFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20 24H18V19C18 18.7348 17.8946 18.4804 17.7071 18.2929C17.5196 18.1054 17.2652 18 17 18H12C11.7348 18 11.4804 18.1054 11.2929 18.2929C11.1054 18.4804 11 18.7348 11 19V24H9C8.73478 24 8.48043 24.1054 8.29289 24.2929C8.10536 24.4804 8 24.7348 8 25V42C8 42.2652 8.10536 42.5196 8.29289 42.7071C8.48043 42.8946 8.73478 43 9 43H10V44.5C10 44.8978 10.158 45.2794 10.4393 45.5607C10.7206 45.842 11.1022 46 11.5 46C11.8978 46 12.2794 45.842 12.5607 45.5607C12.842 45.2794 13 44.8978 13 44.5V43H16V44.5C16 44.8978 16.158 45.2794 16.4393 45.5607C16.7206 45.842 17.1022 46 17.5 46C17.8978 46 18.2794 45.842 18.5607 45.5607C18.842 45.2794 19 44.8978 19 44.5V43H20C20.2652 43 20.5196 42.8946 20.7071 42.7071C20.8946 42.5196 21 42.2652 21 42V25C21 24.7348 20.8946 24.4804 20.7071 24.2929C20.5196 24.1054 20.2652 24 20 24ZM13 24V20.5C13 20.3674 13.0527 20.2402 13.1464 20.1464C13.2402 20.0527 13.3674 20 13.5 20H15.5C15.6326 20 15.7598 20.0527 15.8536 20.1464C15.9473 20.2402 16 20.3674 16 20.5V24H13Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33 12C35.2091 12 37 10.2091 37 8C37 5.79086 35.2091 4 33 4C30.7909 4 29 5.79086 29 8C29 10.2091 30.7909 12 33 12Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37 13H29C27.6739 13 26.4022 13.5268 25.4645 14.4645C24.5268 15.4021 24 16.6739 24 18V27.88C23.9866 28.3993 24.168 28.9049 24.5085 29.2972C24.849 29.6895 25.324 29.9402 25.84 30C26.2467 30.033 26.6532 29.9348 27 29.72V43.36C26.9841 43.9983 27.2036 44.6202 27.6167 45.1071C28.0298 45.5939 28.6076 45.9118 29.24 46C29.5895 46.0365 29.9428 45.999 30.2767 45.8899C30.6107 45.7807 30.918 45.6023 31.1784 45.3664C31.4388 45.1306 31.6466 44.8424 31.7882 44.5208C31.9297 44.1992 32.0019 43.8514 32 43.5V33C32 32.7348 32.1054 32.4804 32.2929 32.2929C32.4805 32.1054 32.7348 32 33 32C33.2652 32 33.5196 32.1054 33.7071 32.2929C33.8947 32.4804 34 32.7348 34 33V43.36C33.9841 43.9983 34.2036 44.6202 34.6167 45.1071C35.0298 45.5939 35.6076 45.9118 36.24 46C36.5895 46.0365 36.9428 45.999 37.2767 45.8899C37.6107 45.7807 37.918 45.6023 38.1784 45.3664C38.4388 45.1306 38.6466 44.8424 38.7882 44.5208C38.9297 44.1992 39.0019 43.8514 39 43.5V29.72C39.348 29.9313 39.7545 30.0259 40.16 29.99C40.6743 29.9304 41.1479 29.6811 41.4881 29.2909C41.8284 28.9007 42.0109 28.3976 42 27.88V18C42 16.6739 41.4732 15.4021 40.5356 14.4645C39.5979 13.5268 38.3261 13 37 13Z",
    fill: color
  }));
};

IconGuestsFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconGuestsFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconGuestsFilled;
exports.default = _default;